module.exports = __webpack_public_path__ + "static/media/analysisIcon.f7d48ad7.png";